import { fork } from "redux-saga/effects";
import { watchIdentifyFetch } from "./identify";
import { watchFaceFetch } from "./face";

function* rootSaga() {
    yield fork(watchIdentifyFetch);
    yield fork(watchFaceFetch);
}

export default rootSaga;